import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowCardHeader: Components<Theme>['MuiCardHeader'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      padding: '16px',
    },
  },
};
